<xp-dialog *ngIf="visibleEditBoundaryFeeDialog" class="edit-boundary-dialog">
  <xp-dialog-header class="vehicle-dialog-header" heading="Edit Boundary Fee" (closeClick)="cancel()"></xp-dialog-header>

  <mat-card-content>
    <xp-loading *ngIf="isLoading" class="spinner-center" [diameter]="48"></xp-loading>

    <ng-container *ngIf="!isLoading">
      <div class="boundary-scroll-panel">
        <div class="amount-row">
          <xp-field class="amount-col"
                    label="Boundary Amount"
                    infoIconSrc="/XpressApp/assets/images/info-black.png"
                    infoTooltip="Amount paid by the driver">
            <xp-input type="number"
                      [min]="0"
                      [max]="1000000"
                      suffixText=".00"
                      placeholder="Enter Amount"
                      [value]="boundaryFeeModel.BoundaryAmount"
                      (valueChange)="boundaryFeeModel.BoundaryAmount = $any($event)"></xp-input>
          </xp-field>

          <xp-field class="amount-col"
                    label="Processing fee"
                    infoIconSrc="/XpressApp/assets/images/info-black.png"
                    infoTooltip="Payment processing fee collected by Xpress">
            <xp-input class="readonly-input"
                      type="number"
                      [min]="0"
                      [readonly]="true"
                      prefixText="₱"
                      placeholder="Enter Amount"
                      [value]="boundaryFeeModel.BoundaryProcessingFee"
                      (valueChange)="boundaryFeeModel.BoundaryProcessingFee = $any($event)"></xp-input>
          </xp-field>

          <div class="earn-note">
            You will receive ₱{{boundaryFeeModel.GetBoundaryEarning()}}
          </div>
        </div>

        <xp-field class="section" label="Days Applied">
          <xp-toggle-buttons [options]="dayOptions"
                             [selected]="boundaryFeeModel.BoundaryAvailableDays"
                             (toggled)="toggleDay($event)"></xp-toggle-buttons>
        </xp-field>

        <xp-field class="section duration-field"
                  label="Boundary Duration"
                  infoIconSrc="/XpressApp/assets/images/info-black.png"
                  infoTooltip="Period of time the fee lasts for."
                  errorText="End Time should be greater than Start Time"
                  [showError]="!!timeStartString && !!timeEndString && timeStartString > timeEndString">
          <div class="duration-row">
            <div class="time-col">
              <label class="time-label">Start Time</label>
              <xp-input type="time"
                        [value]="timeStartString"
                        (valueChange)="timeStartString = $any($event)"></xp-input>
            </div>
            <div class="time-col">
              <label class="time-label">End Time</label>
              <xp-input type="time"
                        [value]="timeEndString"
                        (valueChange)="timeEndString = $any($event)"></xp-input>
            </div>
          </div>
        </xp-field>
      </div>
    </ng-container>
  </mat-card-content>

  <div class="dialog-actions" *ngIf="!isLoading">
    <button mat-flat-button color="primary" type="button" class="save-btn"
            [disabled]="!boundaryFeeModel.IsBoundaryFieldsFilled() || !timeStartString || !timeEndString || timeStartString > timeEndString"
            (click)="saveBoundaryFee()">Save</button>
  </div>
</xp-dialog>
